"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useExpressionEditor = exports.ExpressionEditorContext = void 0;
const react_1 = require("react");
exports.ExpressionEditorContext = (0, react_1.createContext)({
    textAreaRef: { current: null },
    selectedFunction: null,
    setSelectedFunction: (_fn) => { },
});
const useExpressionEditor = () => {
    return (0, react_1.useContext)(exports.ExpressionEditorContext);
};
exports.useExpressionEditor = useExpressionEditor;
